import styled from 'styled-components';

export const Label = styled.div`
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.5);
`;

export const ValueRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.expand ? 'space-between' : '')};
  align-items: flex-start;
  padding-top: 4px;
  padding-bottom: 2px;
  width: 100%;
`;

export const DeltaChildrenWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${(props) => (props.expand ? 'flex-end' : 'space-between')};
`;

export const ValueWrapper = styled.div`
  display: flex;
`;

export const Value = styled.div`
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #101938;
`;

export const Delta = styled.div`
  color: ${(props) => (props.rise ? '#abd400' : '#ff47b4')};
  align-self: center;
  font-size: 12px;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  margin-top: 5px;
`;

export const Description = styled.small`
  font-size: 12px;
  text-align: left;
`;
